import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import { createChecksumStream } from "@smithy/util-stream";
import { getChecksum } from "./getChecksum";
import { getChecksumAlgorithmListForResponse } from "./getChecksumAlgorithmListForResponse";
import { getChecksumLocationName } from "./getChecksumLocationName";
import { isStreaming } from "./isStreaming";
import { selectChecksumAlgorithmFunction } from "./selectChecksumAlgorithmFunction";
export var validateChecksumFromResponse = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, _ref) {
    var config, responseAlgorithms, checksumAlgorithms, responseBody, responseHeaders, _iterator, _step, algorithm, responseHeader, checksumFromResponse, checksumAlgorithmFn, base64Encoder, checksum;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            config = _ref.config, responseAlgorithms = _ref.responseAlgorithms;
            checksumAlgorithms = getChecksumAlgorithmListForResponse(responseAlgorithms);
            responseBody = response.body, responseHeaders = response.headers;
            _iterator = _createForOfIteratorHelper(checksumAlgorithms);
            _context.prev = 4;
            _iterator.s();
          case 6:
            if ((_step = _iterator.n()).done) {
              _context.next = 24;
              break;
            }
            algorithm = _step.value;
            responseHeader = getChecksumLocationName(algorithm);
            checksumFromResponse = responseHeaders[responseHeader];
            if (!checksumFromResponse) {
              _context.next = 22;
              break;
            }
            checksumAlgorithmFn = selectChecksumAlgorithmFunction(algorithm, config);
            base64Encoder = config.base64Encoder;
            if (!isStreaming(responseBody)) {
              _context.next = 16;
              break;
            }
            response.body = createChecksumStream({
              expectedChecksum: checksumFromResponse,
              checksumSourceLocation: responseHeader,
              checksum: new checksumAlgorithmFn(),
              source: responseBody,
              base64Encoder: base64Encoder
            });
            return _context.abrupt("return");
          case 16:
            _context.next = 18;
            return getChecksum(responseBody, {
              checksumAlgorithmFn: checksumAlgorithmFn,
              base64Encoder: base64Encoder
            });
          case 18:
            checksum = _context.sent;
            if (!(checksum === checksumFromResponse)) {
              _context.next = 21;
              break;
            }
            return _context.abrupt("break", 24);
          case 21:
            throw new Error("Checksum mismatch: expected \"".concat(checksum, "\" but received \"").concat(checksumFromResponse, "\"") + " in response header \"".concat(responseHeader, "\"."));
          case 22:
            _context.next = 6;
            break;
          case 24:
            _context.next = 29;
            break;
          case 26:
            _context.prev = 26;
            _context.t0 = _context["catch"](4);
            _iterator.e(_context.t0);
          case 29:
            _context.prev = 29;
            _iterator.f();
            return _context.finish(29);
          case 32:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 26, 29, 32]]);
  }));
  return function validateChecksumFromResponse(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();